module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-header'), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "search-type"
  }, [_c('label', {
    class: _vm.search_type == 1 ? 'active' : null,
    on: {
      "click": function($event) {
        _vm.handelSelectSearchType(1)
      }
    }
  }, [_vm._v("找人")]), _vm._v(" "), _c('label', {
    class: _vm.search_type == 2 ? 'active' : null,
    on: {
      "click": function($event) {
        _vm.handelSelectSearchType(2)
      }
    }
  }, [_vm._v("找工作")])]), _vm._v(" "), _c('div', {
    staticClass: "search-wrap"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.search_type == 1 ? '输入找人的姓名' : '输入要找的工作岗位'
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-btn"
  }, [_vm._v("搜索")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_user_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickPerson(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.user_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             " + _vm._s(item.company) + " - " + _vm._s(item.job_name) + "\n            ")])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_job_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickJob(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.job_name) + "\n              \n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             \n             " + _vm._s(item.company) + " - " + _vm._s(item.salary) + "\n            ")])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "search-list clearfix"
  }, _vm._l((_vm.search_job_result), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.handelClickCompany(item)
        }
      }
    }, [_c('div', {
      staticClass: "search-item"
    }, [_c('div', {
      staticClass: "search-item-title"
    }, [_vm._v("\n              " + _vm._s(item.company) + " - " + _vm._s(item.salary) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "search-item-intro"
    }, [_vm._v("\n             \n             " + _vm._s(item.job_name) + "\n            ")])])])
  }))]), _vm._v(" "), _c('foter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad93a978","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/happypack/loader.js?id=ESLint!./app/views/search/ViewSearch.vue
// module id = 163
// module chunks = 3 4